define('gigaset_recurring/classes/provider/billwerk/steps/payment',[
	"jquery",
	"lodash",
	"./_abstract",
	"cartware/jquery/bem",
	"cartware/components/Registry",
	"cartware/components/Logger",
	"gigaset_recurring/components/checkout/provider/billwerk/payment/method/creditcard",
	"gigaset_recurring/components/checkout/provider/billwerk/payment/method/debit",
	"shoptheme/components/cartware/checkout"
], function(
	$,
	_,
	AbstractStep,
	BEM,
	Registry,
	Logger,
	CreditCardComponent,
	DebitComponent,
	CartwareCheckoutComponent
) {

	var PAYMENT_METHOD_CREDITCARD = "CreditCard";

	var PAYMENT_METHODS_WHITELABEL = ["CreditCard", "DirectDebit", "OnAccount"];

	var PAYMENT_METHOD_COMPONENT_MAP = {
		"CreditCard": CreditCardComponent,
		"DirectDebit": DebitComponent
	};

	function PaymentStep() {
		AbstractStep.call(this);

		this.initializedMethodsMap = {};
		this.logger = Logger.getLogger("gigaset_recurring.payment");
	}

	PaymentStep.prototype = _.create(new AbstractStep, {
		constructor: PaymentStep,

		_displayInSidebar: false,

		initialize: function() {
			this.block = BEM.block("gigaset-recurring-checkout-payment");
			this.methodsBlock = BEM.block(this.block.find("." + BEM.buildBlockClassname("sp-methods")));
			this.methodsList = this.methodsBlock.getElements("list");
			this.methodTmpl = _.template(this.methodsBlock.getElements("tmpl-item").html());
			this.proceedButton = this.block.getElements("proceed-button");
			this.backButton = this.block.getElements("back-button");
			this.paymentService = this.getData("paymentService");

			this.paymentMethods = this.paymentService.getAvailablePaymentMethods();

			var paymentOptions = [];
			_.forEach(this.paymentMethods, _.bind(function(providerInfo, provider) {
				var emptyProviderInfo = _.isEmpty(providerInfo);

				if (emptyProviderInfo || _.get(providerInfo, "BlackLabel")) {
					paymentOptions.push({
						label: this.getMethodLabel(provider),
						value: provider
					});

					if (emptyProviderInfo) return;
				}

				_.forEach(PAYMENT_METHODS_WHITELABEL, _.bind(function(method) {
					var providerMethod = method + ':' + provider;

					if ("DirectDebit" === method) {
						providerMethod = 'Debit:' + provider;
					}

					if (true === _.get(providerInfo, method)) {
						paymentOptions.push({
							label: this.getMethodLabel(providerMethod),
							value: providerMethod
						});
					}
				}, this));
			}, this));

			_.forEach(paymentOptions, _.bind(function(option, key) {
				var methodHtml = this.methodTmpl(_.merge({
					id: "method-" + key,
					title: option.value
				}, option));

				this.methodsList.append(methodHtml);
			}, this));

			this.logger.info("paymentMethods", this.paymentMethods);
			this.logger.info("paymentMethodsEnum", this.paymentService.getAvailablePaymentMethodEnum());

			this.bindEvents();

			if (1 === paymentOptions.length) {
				this.methodsList.find('[name=payment_method]').click();
			}

			// This provides a tooltip for the creditcard
			Registry().retrieve("component.dispatcher", function(dispatcher) {
				dispatcher.initializeComponent(CartwareCheckoutComponent);
			});
		},

		bindEvents: function() {
			this.methodsBlock.on("change", _.bind(this.onMethodChange, this));
			this.proceedButton.on("click", _.bind(this.submit, this));
			this.backButton.on("click", _.bind(this.previous, this));
		},

		validate: function() {
			var formData = this.collectFormData(),
				method = this.getMethodByValue(this.getSelectedMethod()),
				component = _.get(this.initializedMethodsMap, [method, "component"]);

			if (component && _.isFunction(component.validate)) {
				return component.validate();
			}

			return true;
		},

		collectFormData: function() {
			var values = {
				method: "recurring_payment"
			};

			this.getSelectedContentNode()
				.find("select, input, textarea")
				.each(function() { var input = $(this); values[input.attr("name")] = input.val(); });

			if (PAYMENT_METHOD_CREDITCARD === this.getMethodByValue(this.getSelectedMethod())) {
				var expiry = _.get(values, "expiry");
				if (expiry) {
					var expirySplit = expiry.split("/");

					values.expiryMonth = _.trim(_.get(expirySplit, "0", ""));
					values.expiryYear = _.trim(_.get(expirySplit, "1", ""));

					if (values.expiryYear.length === 2) {
						values.expiryYear = "20" + values.expiryYear; // this should do for the next few decades...
					}

					delete values.expiry;
				}

				_.set(values, "cardNumber", _.get(values, "cardNumber", "").replace(/\s/g, ""));
			}

			values.bearer = this.getSelectedMethod();

			return {
				payment: values
			};
		},

		getSelectedInput: function() {
			return this.methodsList.find("[name=payment_method]:checked");
		},

		getSelectedMethod: function() {
			return this.getSelectedInput().val();
		},

		getSelectedContentNode: function() {
			return this.getContentNodeOfInput(this.getSelectedInput());
		},

		getContentNodeOfInput: function(input) {
			var activeTitle = input.parents("." + BEM.buildElementClassname("sp-methods", "list-item-title")),
				activeContent = activeTitle.next("." + BEM.buildElementClassname("sp-methods", "list-item-value"));

			return activeContent;
		},

		onMethodChange: function() {
			var input = this.getSelectedInput(),
				value = input.val(),
				method = this.getMethodByValue(value),
				allContents = this.methodsBlock.getElements("list-item-value"),
				activeContent = this.getContentNodeOfInput(input);

			allContents.not(activeContent).find(".form-list:first").addClass("hidden");
			activeContent.find(".form-list:first").removeClass("hidden");

			this.initializeMethod(method, activeContent.find(".form-list:first"));
			this.proceedButton.attr("disabled", false);
		},

		initializeMethod: function(method, container) {
			if (method in this.initializedMethodsMap) return;

			this.initializedMethodsMap[method] = {};

			var template = _.template(this.block.getElements("tmpl-payment-method").filter("#tmpl-payment-method-" + method).html()),
				self = this;

			container.append(template(this.getData()));

			var component = _.get(PAYMENT_METHOD_COMPONENT_MAP, method);
			if (component) {
				Registry().retrieve("component.dispatcher", function(dispatcher) {
					dispatcher.initializeComponent(component, function(instance) {
						self.initializedMethodsMap[method].component = instance;
					});
				});
			}
		},

		getMethodByValue: function(value) {
			return value.replace(/:.*/, "");
		},

		getMethodLabel: function(providerMethod) {
			var method = providerMethod.replace(/:.*/, "");

			return window.Translator.translate(method);
		},

		/**
		 * Collect data from the step and save it via this.addData
		 * @returns {Promise}
		 */
		saveFormData: function() {
			this.proceedButton.button("loading");

			return this.saveFormDataServerSide().always(_.bind(function() {
				this.proceedButton.button("reset");
			}, this));
		},

		// Transfer only method. Everything else requires PCI-DSS
		_saveFormDataServerSide: function(formData) {
			return AbstractStep.prototype._saveFormDataServerSide.call(this, {
				payment: {
					method: _.get(formData, 'payment.method')
				}
			});
		}
	});

	return PaymentStep;

});
